import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AdminApp } from "./admin/AdminApp";
import { Events } from "./admin/Events";
import { Feedback } from "./admin/Feedback";
import { Feed } from "./admin/Feed";
import { Overview } from "./admin/Overview";
import { SpreadDetail } from "./admin/SpreadDetail";
import { Spreads } from "./admin/Spreads";
import { UserDetail, Users } from "./admin/Users";
import { Landing } from "./pages/Landing";
import { Privacy } from "./pages/Privacy";
import { SpreadPage } from "./pages/Spread";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/s/:id" element={<SpreadPage />} />
        <Route path="/admin" element={<AdminApp />}>
          <Route index element={<Overview />} />
          <Route path="spreads" element={<Spreads />} />
          <Route path="spreads/:id" element={<SpreadDetail />} />
          <Route path="feed" element={<Feed />} />
          <Route path="users" element={<Users />} />
          <Route path="users/:sub" element={<UserDetail />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="events" element={<Events />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
